import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import * as fromUser from '../../user/store/user.reducers';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-user-setting',
    templateUrl: './user-setting.component.html',
    styleUrls: ['./user-setting.component.scss'],
    standalone: false
})
export class UserSettingComponent implements OnInit {

  userState: Observable<fromUser.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.userState = this.store.select('user');
  }

}
